import { useCallback, useMemo } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";
import { API } from "@/lib/api";

export const useAdminApi = () => {
  const { getToken } = useAuth();
  const headers = useCallback(async () => ({ Authorization: `Bearer ${await getToken()}` }), [getToken]);
  const get = useCallback(async (p) => (await axios.get(`${API}${p}`, { headers: await headers() })).data, [headers]);
  const post = useCallback(async (p, body) => (await axios.post(`${API}${p}`, body, { headers: await headers() })).data, [headers]);
  const put = useCallback(async (p, body) => (await axios.put(`${API}${p}`, body, { headers: await headers() })).data, [headers]);
  const patch = useCallback(async (p, body) => (await axios.patch(`${API}${p}`, body, { headers: await headers() })).data, [headers]);
  const del = useCallback(async (p) => (await axios.delete(`${API}${p}`, { headers: await headers() })).data, [headers]);
  return useMemo(() => ({ get, post, put, patch, del, headers }), [get, post, put, patch, del, headers]);
};

export const playChime = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [880, 1320].forEach((f, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.frequency.value = f;
      o.connect(g);
      g.connect(ctx.destination);
      const t = ctx.currentTime + i * 0.18;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.3, t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.35);
      o.start(t);
      o.stop(t + 0.4);
    });
  } catch {}
};

export const fmtDate = (iso) => new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
